import { render } from "./AdminRiderrateList.vue?vue&type=template&id=c965aae4&scoped=true&ts=true&lang=true"
import script from "./AdminRiderrateList.vue?vue&type=script&lang=ts"
export * from "./AdminRiderrateList.vue?vue&type=script&lang=ts"

import "./AdminRiderrateList.vue?vue&type=style&index=0&id=c965aae4&scoped=true&lang=css"

import exportComponent from "/var/www/adminold.quickup.uk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c965aae4"]])

export default __exports__